import { ConnectionState, SyncClient } from 'twilio-sync'
import { syncType } from './syncTypes'
import { debug } from '@bt-react/libs/Logger'
import apiGateway from '../../../services/apiGateway'
import { ThunkAction } from 'redux-thunk'
import { ReduxAction, State } from '../../reducers/reducerType'
import { addEntry } from '../../../lib/audit'

export const syncClientEstablished = client => ({ type: syncType.SYNC_CLIENT_ESTABLISHED, payload: client })
export const setSyncListenersAdded = () => ({ type: syncType.SET_SYNC_CLIENT_LISTENERS })
export const setSyncClientConnected = (client: SyncClient) => ({ type: syncType.SYNC_CLIENT_CONNECTED, payload: client })
export const setSyncClientConnecting = () => ({ type: syncType.SYNC_CLIENT_CONNECTING })
export const setSyncClientDisconnected = (token: string) => ({ type: syncType.SYNC_CLIENT_DISCONNECTED, payload: token })
export const handleSyncConnectionStateChange = (connectionState: ConnectionState, client: SyncClient, token: string) => {

  debug(`Twilio Sync connection state set to ${connectionState}`)

  switch (connectionState) {

    case 'connected':
      return setSyncClientConnected(client)
    case 'disconnected':
      addEntry('PresenterService', 'SyncConnectionStateChange', `Sync client disconnected`)
      return setSyncClientDisconnected(token)
    case 'connecting':
      return setSyncClientConnecting()
    default:
      return { type: 'SYNC_CONNECTION_STATE_CHANGED', payload: connectionState }

  }

}
export const setTokenRenewalError = (errorMessage: string): ReduxAction  => ({ type: syncType.TOKEN_RENEWAL_ERROR, payload: errorMessage })
export const setTokenRenewalSuccess = (token: string): ReduxAction => ({ type: syncType.TOKEN_RENEWAL_SUCCESS, payload: token })
export const renewToken = (client: SyncClient, roomname: string, username: string): ThunkAction<Promise<ReduxAction>, State, null, ReduxAction> => async (dispatch) => {

  debug(`Twilio token is being renewed`)

  let tokenResponse

  try {

    tokenResponse = await apiGateway.fetchToken(roomname, username)

  }
  catch (e) {

    addEntry('PresenterService', 'TwilioTokenRenewal', `Attempt to fetchToken for renewal failed. Error: ${e}`)
    return dispatch(setTokenRenewalError('Token fetch failed'))

  }

  const { data } = tokenResponse

  try {

    await client.updateToken(data)

  }
  catch (e) {

    addEntry('PresenterService', 'TwilioTokenRenewal', `Attempt to updateToken against client failed. Error: ${e}`)
    return dispatch(setTokenRenewalError('Failure updating token'))

  }

  return dispatch(setTokenRenewalSuccess(data))

}

export default {
  syncClientEstablished,
  setSyncListenersAdded,
  setSyncClientConnected,
  setSyncClientDisconnected,
  setSyncClientConnecting,
  handleSyncConnectionStateChange,
  setTokenRenewalError,
  setTokenRenewalSuccess,
  renewToken
}
